/**
 * Login Entry Point
 * Samostatný bundle pro login stránku
 */

// Import Bootstrap (potřebný pro modaly)
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

// Import stylů specifických pro login
import '../css/sass/styles.sass';

// Import RedaAuth konfigurace
import './auth-config.js';

// Import registration field validation
import './registration-validation.js';

console.log('✓ Login bundle loaded');
